<template>
    <div class="main-body">
        <div class="header">新闻列表</div>
        <div class="out">

            <div class="search2">
              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="clear: both;"></div>
            </div>


            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column prop="title" label="标题"></el-table-column>

              <el-table-column prop="imgPath" label="图片">
                <template slot-scope="scope">
                  <el-image :src="imgHost+scope.row.headImg" style="width: 40px;height: 40px;"/>
                </template>
              </el-table-column>

                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag type="success" slot="reference" v-if="scope.row.status==1">正常</el-tag>
                        <el-tag type="danger" slot="reference" v-if="scope.row.status==2">禁用</el-tag>
                    </template>
                </el-table-column>

              <el-table-column prop="createTime" label="时间" :formatter="timefilter" ></el-table-column>

              <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="success" size="mini" @click="handleInfo(scope.$index, scope.row)">查看</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="pageSize"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:type2="type2" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:articleClassList="articleClassList" v-bind:networkList="networkList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>
    import {getStaffDTO} from "@/utils/auth";
    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    import Edit from "./Edit";
    import Add from "./Add";
    import { timefilters } from '@/common/times';

    export default {
        name: "PageGov",
        components:{Add,Edit},
        data(){
            return{


              imgHost:this.$imgUrl,

                tableLoading:false,

                showModalAdd:false,
                showModalEdit:false,
                showModalEditStaff:false,
                showModalActivityPeoplePage:false,

                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                roleName:'',
                articleClassList:[],
                th:0,
                status1List:[
        {label:'全部',value:0},
        {label:'正常',value:1},
        {label:'禁用',value:2}
      ],
                searchForm:{
                    title:'',
                    status:null,
                    communityCode:'',
                    networkCode:'',
                    startTime:'',
                    endTime:''
                },
                searchData:[],
                communityList:[],
                networkList:[],

              type2:2,

            }
        },

        created(){
            this.roleName=getStaffDTO().roleName;
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
          timefilter(row,index,column){
            return timefilters(column)
          },

          init(){

            },
             dataChange(val) {
                this.searchForm.startTime = val[0]
                this.searchForm.endTime = val[1]
                },
            getTime(row,index,column){
                return timefilters(column)
            },
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            handleDelete(index, row){
                this.$confirm('是否废弃此活动?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                }).then(() => {
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"Article/Revocation",
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            articleCode:row.articleCode
                        }
                    }).then( (response)=> {
                        if(response.data.error == 0){
                            this.$message({type: 'info', message:'废弃成功'});
                            this.getList();
                        }
                    }).catch(function (error) {
                        console.log(error)
                    });
                }).catch(e=>e)
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row,false);
                this.showModalEdit = !this.showModalEdit;
            },
            handlePeople(index, row) {
                this.$refs.myActivityPeople.init(row);
                this.showModalActivityPeoplePage = !this.showMshowModalActivityPeoplePageodalEdit;
            },
            handleInfo(index, row) {
                this.$refs.myEdit.init(row,true);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
             closeActivityPeoplePage:function(){
                this.showModalActivityPeoplePage = !this.showModalActivityPeoplePage;
            },
            statusTitle(row){
                if(row.publishRegion == 0){
                    return "服务类";
                }
                if(row.publishRegion == 1){
                    return "商品类";
                }
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },


            getList(isSearch){
                if(isSearch)this.currentPage=1

                var _this=this
                this.tableLoading=true

                var data={
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex: this.currentPage,
                    pageSize: this.pageSize,
                  type:2,
                }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Article/PageByCommandCenterType",
                    data:data
                }).then( (response)=> {
                  _this.tableLoading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfo.list;
                        this.totalItems = response.data.data.pageInfo.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                  _this.tableLoading = false;
                  console.log(error)
                });
            },



        }
    }
</script>

